import spherelibUtils from 'spherelib-utils'

const { sha256 } = spherelibUtils.algo.hash

const set = async (client, k, v, expiry = 120) => {
  const key = getRedisKey(k)
  const value_str = JSON.stringify(v)

  return client.callByName('redis-worker', 'sendCommand', [
    ['set', key, value_str, 'EX', expiry + ''],
  ])
}

const get = async (client, k) => {
  const key = getRedisKey(k)
  const resp = await client.callByName('redis-worker', 'sendCommand', [['get', key]])

  if (resp === null) {
    return {
      has: false,
    }
  }

  return {
    has: true,
    data: JSON.parse(resp),
  }
}

const getRedisKey = (k) => {
  return `cache-${k}`
}

export const cacheFn = (
  getClient,
  fn,
  { name, expiry = 120, keyFn = defaultKeyFn } = {},
) => {
  if (!name) {
    throw new Error('missing cache name')
  }

  let newFunction = async (...params) => {
    const client = getClient()
    const key = `${name}-${keyFn(...params)}`

    // try get cache first
    const { has, data } = await get(client, key)

    if (has) {
      return data
    }

    const result = await fn(...params)

    // store cache
    await set(client, key, result, expiry)

    return result
  }

  return newFunction
}

export const updateFnCache = async (
  getClient,
  fn,
  params = [],
  { name, expiry = 120, keyFn = defaultKeyFn } = {},
) => {
  if (!name) {
    throw new Error('missing cache name')
  }

  const client = getClient()
  const key = `${name}-${keyFn(...params)}`
  const result = await fn(...params)

  // store cache
  await set(client, key, result, expiry)
}

const defaultKeyFn = (...params) => {
  const str = JSON.stringify(params, deterministicReplacer)
  return sha256(str)
}

const deterministicReplacer = (_, v) =>
  typeof v !== 'object' || v === null || Array.isArray(v)
    ? v
    : Object.fromEntries(
        Object.entries(v).sort(([ka], [kb]) =>
          ka < kb ? -1 : ka > kb ? 1 : 0,
        ),
      )

// TODO call contract with cache
// TODO get json with cache
